import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

/*export const getListAdminJob = createAsyncThunk('/job_status/content', async (nopage) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companySoFileStatus?page=${nopage}`, {})
    return response.data;
})*/

export const getListAdminJob = createAsyncThunk(
    '/job_status/content',
    async ({ page, search, limit }) => {
        const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}/companySoFileStatus`,
            {
                params: {
                    page: page,
                    search: search,
                    limit: limit
                }
            }
        );

        //console.log(page);
        //console.log(limit);

        return response.data;
    }
);

export const jobAdminSlice = createSlice({
    name: 'job_status',
    initialState: {
        isLoading: false,
        job_status: []
    },

   
    extraReducers: (builder) => {
        builder
            .addCase(getListAdminJob.pending, (state) => {
                state.isLoading = true;
            })               
            .addCase(getListAdminJob.fulfilled, (state, action) => {
                state.job_status = action.payload;
                state.isLoading = false;
            })               
            .addCase(getListAdminJob.rejected, (state) => {
                state.isLoading = false;
            });               
    }   
})

export default jobAdminSlice.reducer